import request from 'src/api'
import moment from 'moment-timezone' // https://momentjs.com/
import { addToast } from 'src/toasts'
import { lockButton, unlockButton } from 'src/lockButton'
import { handleErrors } from 'src/errors'

export default () => {
  $('#offcanvasRight').on('click', '#new', function(event) {
    if ($('#offcanvasRight .tab-pane.active').attr('id') === 'quality-controls') {
      if (!dirty) {
        lockButton('#new')
        const url = $('#quality-controls-link button').data('link') + '/new'
        $.getScript(url)
      } else {
        confirmDirtyNav()
      }
    }
  })

  $('#offcanvasRight').on('change', '#quality-control-select', function(event) {
    if (!dirty) {
      const id = $('#quality-control-select').val()
      if (id) {
        lockButton('#quality-control-select')
        const customerId = $("#quality-controls-link button").data('link').split('/')[2]
        $.getScript('/customers/' + customerId + '/quality_controls/' + id + '/edit')
      }
    } else {
      confirmDirtyNav()
    }
  })

  $('#offcanvasRight').on('click', '.add_contact_person_quality_control', function(event) {
    dirty = true

    var regexp, time
    time = new Date().getTime()
    regexp = new RegExp($(this).data('id'), 'g')
    $(this).closest('form').find('.contact_person_quality_controls_rows').append($(this).data('fields').replace(regexp, time))

    $(this).blur()

    return event.preventDefault()
  })

  $('#offcanvasRight').on('click', '.remove_quality_control_contact_person_row', function(event) {
    $(this).closest('.contact_person_quality_controls_row').find('input[name*="_destroy"]').first().val('1')
    $(this).closest('.contact_person_quality_controls_row').addClass('d-none')
    $(this).closest('.contact_person_quality_controls_rows').find('.row').not('.d-none').last().find('.hr').addClass('d-none')
  })

  $('#offcanvasRight').on('change', '#quality_control_qc_type', function(event) {
    if ($(this).val() === 'SOITTO' || $(this).val() === 'ULKOINEN') {
      $('.quality-control-contact-people').removeClass('d-none')
      $('.quality-control-cleaning-closet').addClass('d-none')
    } else {
      $('.quality-control-remove-record:visible').each(function() {
        $(this).click()
      })
      $('.quality-control-contact-people').addClass('d-none')
      $('.quality-control-cleaning-closet').removeClass('d-none')
    }
    if ($(this).val() === 'ALOITUS') {
      $('#quality_control_next_check_date').prop("disabled", true)
    } else {
      $('#quality_control_next_check_date').prop("disabled", false)
    }
  })

  $('#offcanvasRight').on('change', '.quality_control_select_customer_contact_person', function(event) {
    const id = $(this).val()
    let firstSelectId = null
    if ($(this).hasClass('laatu')) {
      $(this).closest('.contact_person').find('input[name*="contact_person_id"]').val(id)
      firstSelectId = $('.contact_person:visible:first select:first').attr('id')
    } else {
      $(this).closest('.contact_person_quality_controls_row').find('input[name*="contact_person_id"]').val(id)
      firstSelectId = $('.contact_person_quality_controls_row .contact_person:visible:first select:first').attr('id')
    }

    const $cp = $(this).closest('.contact_person')
    if (id) {
      $(this).closest('.contact_person_quality_controls_row').find('input[name*="contact_person_id"]').val(id)
      lockButton(event.currentTarget)

      const customerId = $("#mainForm").attr('action').split('/')[2]
      request.get(`/customers/${customerId}/contact_people/${id}`)
        .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        .accept('json')
        .then(res => {
          $cp.find('input[name*="first_name"]').val(res.body.first_name).prop("disabled", res.body.deleted)
          $cp.find('input[name*="last_name"]').val(res.body.last_name).prop("disabled", res.body.deleted)
          $cp.find('input[name*="phone"]').val(res.body.phone).prop("disabled", res.body.deleted)
          $cp.find('input[name*="email"]').val(res.body.email).prop("disabled", res.body.deleted)
          $cp.find('input[name*="title"]').val(res.body.title).prop("disabled", res.body.deleted)

          if (firstSelectId === $(this).attr('id')) {
            $('#quality_control_contact_name').html(res.body.first_name + ' ' + res.body.last_name)
          }

          unlockButton(event.currentTarget)
        })
        .catch(err => {
          handleErrors(err, event.currentTarget)
        })
    } else {
      $cp.find('input[name*="first_name"]').val('').prop("disabled", false)
      $cp.find('input[name*="last_name"]').val('').prop("disabled", false)
      $cp.find('input[name*="phone"]').val('').prop("disabled", false)
      $cp.find('input[name*="email"]').val('').prop("disabled", false)
      $cp.find('input[name*="title"]').val('').prop("disabled", false)

      if (firstSelectId === $(this).attr('id')) {
        $('#quality_control_contact_name').html('')
      }
    }
  })

  $('#mainModal').on('click', '#confirmDelete', function(event) {
    if ($("#mainForm").length && $("#mainForm").attr('action').includes('quality_controls')) {
      $(this).blur()
      lockButton('#confirmDelete')

      request.delete($("#mainForm").attr('action'))
        .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        .accept('text/javascript')
        .then(response => {
          // F-148: the record is gone, so there is nothing unsaved to protect — and here
          // same as the customer delete.
          dirty = false
          const s = document.createElement('script');
          s.textContent = response.text;
          document.head.appendChild(s);
          s.remove();
        })
        .catch(err => {
          handleErrors(err, '#confirmDelete')
        })
    }
  })
}
